import React from "react";

export const Logo = ({ variant = "light", className = "" }) => {
  const onward = variant === "light" ? "text-charcoal" : "text-off-white";
  return (
    <a href="#home" data-testid="logo-link" className={`flex items-center gap-3 group ${className}`}>
      <span className="relative flex h-10 w-10 items-center justify-center">
        <svg viewBox="0 0 48 48" className="h-10 w-10 transition-transform duration-500 group-hover:rotate-6">
          <defs>
            <linearGradient id="goldg" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#FCEB9C" />
              <stop offset="50%" stopColor="#D4AF37" />
              <stop offset="100%" stopColor="#B8942A" />
            </linearGradient>
          </defs>
          <path d="M8 24a16 16 0 1 1 26 12" fill="none" stroke="url(#goldg)" strokeWidth="3" strokeLinecap="round" />
          <path d="M31 20l6-3-1 7z" fill="url(#goldg)" />
          <rect x="16" y="26" width="4" height="8" rx="1" fill="url(#goldg)" />
          <rect x="22" y="21" width="4" height="13" rx="1" fill="url(#goldg)" />
          <rect x="28" y="16" width="4" height="18" rx="1" fill="url(#goldg)" />
        </svg>
      </span>
      <span className="leading-none">
        <span className={`block font-serif text-lg font-semibold tracking-wide ${onward}`}>ONWARD</span>
        <span className="block font-serif text-lg font-semibold tracking-[0.12em] text-gradient-gold -mt-1">TRANSCENDS</span>
      </span>
    </a>
  );
};
